import { Country } from '../../../data/models';

import { BusinessDevelopmentManager } from './business-development-manager.model';
import { CorporateAccount } from './corporate-account.model';
import { DetailedAdministrator } from './detailed-administrator.model';
import { Manager } from './manager.model';
import { StatusChangeReason } from './status-change-reason.model';
import { User } from './user.model';

export enum RetentionPeriod {
  Custom,
  Days90,
  Months36,
}

export enum CustomRetentionPeriodUnit {
  Days,
  Months,
  Years,
}

interface PredefinedRetentionSettings {
  readonly customPeriodLength: null;
  readonly customPeriodUnit: null;
  readonly period: RetentionPeriod.Days90 | RetentionPeriod.Months36;
}

interface CustomRetentionSettings {
  readonly customPeriodLength: number;
  readonly customPeriodUnit: CustomRetentionPeriodUnit;
  readonly period: RetentionPeriod.Custom;
}

export type RetentionSettings = PredefinedRetentionSettings | CustomRetentionSettings;

export interface DetailedCorporateAccount extends CorporateAccount {
  readonly accountManager: Manager;
  readonly accountUsers?: User[];
  readonly administrators?: DetailedAdministrator[];
  readonly archivingEnabled: boolean;
  readonly businessDevelopmentManager: BusinessDevelopmentManager | null;
  readonly closureDate: Date | null;
  readonly country: Country | null;
  readonly forbidCreateTrialAccount: boolean;
  readonly humanReadableId: string;
  readonly preparationEndDate?: Date;
  readonly preparationStartDate?: Date;
  readonly renewalMessageEnabled: boolean;
  readonly retentionEndDate: Date | null;
  readonly retentionSettings: RetentionSettings;
  readonly showBillingInformation: boolean;
  readonly showOutstandingBalance: boolean;
  readonly statusChangeReason: StatusChangeReason | null;
  readonly trialAutoClosureEnabled: boolean;
  readonly trialExpirationDate: Date | null;
  readonly trialProlongationReason: string | null;
  readonly unlimitedPreparationPeriodEnabled: boolean;
}
